<template>
  <main>
    <template v-if="!isLoading">
    <section class="page-header">
      <div class="d-flex align-items-center">
        <span class="clickable mr-2" @click="$router.go(-1)">
          <i class="mdi mdi-chevron-left" style="font-size: 2rem"></i>
        </span>
        <div class="process-header">
          <h2 class="process-title mb-0">{{ form.datos_catastrales }}</h2>
          <h6 class="mt-0">Cuenta: {{ form.cuenta }}</h6>
        </div>
      </div>
      <div class="d-flex">
        <lm-button-v2
          v-if="showGoBackButtonText"
          @click="$router.go(-1)"
        >
        Volver
        </lm-button-v2>
        <template>
          <a-button
            :disabled="true"
            class="ml-3"
            :loading="isProcessing"
            :class="`status-button color-${statusColor}`"
          >
            <template >
              {{ form.estado }}
            </template>
          </a-button>
        </template>
      </div>
    </section>
    <section class="page-content">
      <div class="bg-light rounded-lg p-0 w-100">
        <section class="p-3 rounded-lg bg-white position-relative">
          <div v-if="form.nomenclaturaLatLong">
            <h3 class="col-12">Geolocalización</h3>
            <LmCheckbox
              v-if="geoJsonHasContent"
              class="col-12"
              variant="switch"
              labelSingle="Mostrar Parcelario"
              v-model="enableGeoJson"
            />
            <LmLeaFletMap
              :markerLatLng="form.nomenclaturaLatLong"
              :centerMapCoordinate="form.nomenclaturaLatLong"
              :enableGeoJson="enableGeoJson"
              :geojson="geojson"
              :geojsonEnableTooltips="true"
              geojsonLabelTooltip=""
              geojsonFeaturePropertyTooltip="NOMENCLATU"
              :zoom="15"
              class="col-12"
              height="500px"
              />
          </div>
          <div>
            <h3 class="col-12 mt-4">Trámites Asociados</h3>
            <a-table
              class="col-12"
              bordered
              :columns="tableColumns"
              :data-source="tableData"
              :loading="isTableLoading"
              :customRow="customRow"
              :customHeaderRow="customHeaderRow"
              :pagination="{ hideOnSinglePage: true }"
            >
              <div
                slot="filterDropdown"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                style="padding: 8px"
              >
                <a-input
                  v-ant-ref="c => (searchInput = c)"
                  :placeholder="`Buscar ${column.title}`"
                  :value="selectedKeys[0]"
                  style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
                />
                <a-button
                  type="primary"
                  icon="search"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
                >
                  Buscar
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Borrar
                </a-button>
              </div>
              <a-icon
                slot="filterIcon"
                slot-scope="filtered"
                type="search"
                :style="{ color: filtered ? '#108ee9' : undefined }"
              />
              <span slot="name" slot-scope="text, record">
                {{ text }}
                <a-tooltip v-if="record.metadata.replacement_date"
                  :title="replacementFeedbackDateTooltip(record)">
                  <a-icon type="info-circle" class="ml-2" />
                </a-tooltip>
                <a-tooltip v-if="record.hasBeenDeleted"
                  :title="removedFeedbackDateTooltip(record)">
                  <a-icon type="info-circle" class="ml-2" />
                </a-tooltip>
              </span>
              <span slot="action" slot-scope="text, record">
                <div class="d-flex" style="column-gap: .5rem">
                  <a-tooltip title="Ver detalles">
                    <lm-button-v2 shape="circle" icon="edit" @click="onOpenItem(record)" />
                  </a-tooltip>
                </div>
              </span>
            </a-table>
          </div>
          <div>
            <h3 class="col-12 mt-4">Planos Asociados</h3>
            <a-table
              class="col-12"
              bordered
              :columns="blueprintsTableColumns"
              :data-source="blueprintsTableData"
              :loading="isTableLoading"
              :customRow="customRow"
              :customHeaderRow="customHeaderRow"
              :pagination="{ hideOnSinglePage: true }"
            >
              <div
                slot="filterDropdown"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                style="padding: 8px"
              >
                <a-input
                  v-ant-ref="c => (searchInput = c)"
                  :placeholder="`Buscar ${column.title}`"
                  :value="selectedKeys[0]"
                  style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
                />
                <a-button
                  type="primary"
                  icon="search"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
                >
                  Buscar
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Borrar
                </a-button>
              </div>
              <a-icon
                slot="filterIcon"
                slot-scope="filtered"
                type="search"
                :style="{ color: filtered ? '#108ee9' : undefined }"
              />
              <span slot="action" slot-scope="text, record">
                <div class="d-flex" style="column-gap: .5rem">
                  <a-tooltip title="Ver detalles">
                    <lm-button-v2 shape="circle" icon="edit" @click="onOpenItem(record)" />
                  </a-tooltip>
                </div>
              </span>
            </a-table>
          </div>
          <!-- Action Buttons -->
          <div class="mt-4">
            <LmButton
              :value="$t('cancel')"
              class="col-auto"
              type="button"
              buttonClass="btn-secondary"
              @click="onCancel()"
            />
            <LmButton
              v-if="showCrudButtons && !deleted && !hideSaveButton"
              :value="$t('save')"
              class="col-auto"
              type="button"
              buttonClass="btn-primary"
              @click="onSubmit()"
            />
            <LmButton
              v-if="showCrudButtons && isOnEditMode && !deleted"
              :value="$t('delete')"
              class="col-auto"
              type="button"
              action="delete"
              buttonClass="btn-danger"
              @click="onDelete()"
            />
          </div>
        </section>
      </div>
      <!-- Toolbar -->
      <LmToolbar
        v-if="!hideToolbar"
        ref="toolbar"
        :isOnEditMode="isOnEditMode"
        :items="toolbarItems"
        :config="toolbarConfig"
      />
    </section>
    </template>
    <LmLoading v-else />
  </main>
</template>

<script>
import moment from 'moment'
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmHtmlContent from '@/components/form/elements/LmHtmlContent'
import LmFormBuilder from '@/components/LmFormBuilder'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButtonV2 from '@/components/form/elements/LmButtonV2'
import LmLeaFletMap from '@/components/LmLeaFletMap.vue'
import LmCheckbox from '@/components/form/elements/LmCheckbox'

import LmToolbar from '@/components/lmToolBar'

import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  components: {
    LmFormBuilder,
    LmButton,
    LmTreeSelect,
    LmTextInput,
    LmNumberInput,
    LmEmailInput,
    LmHtmlContent,
    LmToolbar,
    LmButtonV2,
    LmLeaFletMap,
    LmCheckbox
  },
  props: {
    showCrudButtons: {
      type: Boolean,
      default: false
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    isOnModalEditMode: {
      type: Boolean,
      default: false
    },
    pathToRedirectOnCancel: {
      type: String,
      default: ''
    },
    peopleTypeId: {
      type: String,
      default: null
    },
    personData: {
      type: Object,
      default: null
    },
    hideToolbar: {
      type: Boolean,
      default: false
    },
    hideSaveButton: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      screenWidth: screen.width,
      toolbarMode: null,
      published: false,
      deleted: false,
      idType: [],
      form: {
      },
      processes: [],
      blueprints: [],
      isTableLoading: true,
      isBlueprintsTableLoading: true,
      enableGeoJson: false,
      geojson: {},
      isLoading: false
    }
  },
  computed: {
    statusColor () {
      const estado = this.form?.estado?.trim()
      if (estado === 'Ficha Activa') {
        return 7
      } else if (estado === 'Ratificacion de p.h.') {
        return 8
      } else {
        return 12
      }
    },
    formbuilderPath () {
      return `/formbuilder/${this.formbuilderId}`
    },
    dataPathOnEditMode () {
      let targetEndpoint = ''
      if (this.isOnEditMode) {
        targetEndpoint = `/people/${this.$route?.params?.id}`
      }
      if (this.isOnModalEditMode) {
        targetEndpoint = `/people/${this.personData?._id}`
      }
      return targetEndpoint
    },
    toolbarItems () {
      let items = []
      if (this.isOnEditMode) {
        items = [
          'auditMovements'
        ]
      }
      return items
    },
    toolbarConfig () {
      return {
        auditMovements: {
          serviceName: 'people'
        }
      }
    },
    tableColumns () {
      return [
        {
          title: 'Número',
          dataIndex: 'processNumber',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender'
          },
          onFilter: (value, record) => {
            const processNumber = record.processNumber || ''
            return processNumber
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          },
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              this.searchInput.focus()
            }
          }
        },
        {
          title: 'Nombre',
          dataIndex: 'processName'
        },
        {
          title: 'Alias',
          dataIndex: 'processTypeAlias'
        },
        {
          title: 'Estado',
          dataIndex: 'lumbreStatusName'
        },
        {
          title: 'Fecha',
          dataIndex: 'createdAt'
        },
        {
          title: 'Acciones',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },

    tableData () {
      return this.processes.map((el, index) => {
        return {
          key: index,
          processId: el._id,
          processName: el.processName,
          processTypeAlias: el.processTypeAlias,
          processNumber: el.processNumber,
          lumbreStatusName: el.lumbreStatusName,
          processTypeId: el.processTypeId,
          editSlug: el.editSlug,
          createdAt: moment(el.createdAt).format('DD [de] MMM, YYYY - HH:mm')
        }
      })
    },

    blueprintsTableColumns () {
      return [
        {
          title: 'Cuenta',
          dataIndex: 'nomenclaturaCuenta',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender'
          },
          onFilter: (value, record) => {
            const nomenclaturaCuenta = record.nomenclaturaCuenta || ''
            return nomenclaturaCuenta
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          },
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              this.searchInput.focus()
            }
          }
        },
        {
          title: 'Tipo',
          dataIndex: 'typeAlias'
        },
        {
          title: 'Nombre',
          dataIndex: 'name'
        },
        {
          title: 'Nomenclatura',
          dataIndex: 'nomenclaturaCode'
        },
        {
          title: 'Version',
          dataIndex: 'version'
        },
        {
          title: 'Estado',
          dataIndex: 'lumbreStatusName'
        },
        {
          title: 'Fecha',
          dataIndex: 'createdAt'
        },
        {
          title: 'Acciones',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },

    blueprintsTableData () {
      return this.blueprints.map((el, index) => {
        return {
          key: index,
          blueprintId: el._id,
          name: el.name,
          typeAlias: el.typeAlias,
          nomenclaturaCuenta: el.nomenclaturaCuenta,
          nomenclaturaCode: el.nomenclaturaCode,
          lumbreStatusName: el.lumbreStatusName,
          processTypeId: el.processTypeId,
          version: el.version,
          editSlug: el.editSlug,
          createdAt: moment(el.createdAt).format('DD [de] MMM, YYYY - HH:mm')
        }
      })
    },
    geoJsonHasContent () {
      return Object.keys(this.geojson).length > 0
    }
  },
  methods: {
    onCancel () {
      if (this.calledAsComponent) {
        this.$emit('cancel')
      } else {
        this.$router.push(this.pathToRedirectOnCancel)
      }
    },
    updateForm (event) {
      this.form = Object.assign({}, this.form, event)
    },
    async loadRelatedProcesses () {
      if (this.$route.params.id) {
        try {
          const processesResponse = await commonsApi.axiosGetWrapper(`/nomenclaturas/relatedprocesses/${this.$route.params.id}`)
          this.processes = processesResponse.data
        } catch (error) {
          console.log(error)
        } finally {
          this.isTableLoading = false
        }
      }
    },
    async loadRelatedBlueprints () {
      if (this.$route.params.id) {
        try {
          const response = await commonsApi.axiosGetWrapper(`/nomenclaturas/relatedblueprints/${this.$route.params.id}`)
          this.blueprints = response.data
        } catch (error) {
          console.log(error)
        } finally {
          this.isBlueprintsTableLoading = false
        }
      }
    },
    async loadContentOnEditMode () {
      if (this.isOnEditMode) {
        try {
          this.isLoading = true
          // const geoResponse = await commonsApi.axiosGetWrapper('/parcelarias/geojson')
          // this.geojson = geoResponse.data
          const response = await commonsApi.axiosGetWrapper(`/nomenclaturas/${this.$route.params.id}`)
          this.form = response.data
          await this.loadRelatedProcesses()
          this.loadRelatedBlueprints()
        } catch (error) {
          console.log(error)
        } finally {
          this.isLoading = false
        }
      }
    },
    customRow (record, index) {
      return {
        class: 'a-table-row'
      }
    },

    customHeaderRow (column, index) {
      return {
        class: 'a-table-header-row'
      }
    },
    onOpenItem (item) {
      this.$router.push(item.editSlug)
    },
    handleSearch (selectedKeys, confirm, dataIndex) {
      confirm()
      this.searchText = selectedKeys[0]
      this.searchedColumn = dataIndex
    },

    handleReset (clearFilters) {
      clearFilters()
      this.searchText = ''
    }
  },
  async created () {
    try {
      await this.loadContentOnEditMode()
    } catch (error) {
      console.log(error)
    }
  }
}
</script>

<style scoped>
.page-header {
  position: sticky;
  top: 0;
  background-color: white;
  padding: 1rem 2rem;
  z-index: 4;
  border-bottom: 2px solid #eaeaea;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 95px;
}

#lm-leaflet-map {
  z-index: 0;
}

.page-content {
  width: calc(100% + 1rem);
  min-height: calc(100vh - 70px - 60px - 95px);
  margin-left: auto;
  /* display: flex; */

  display: grid;
  grid-template-columns: calc(100% - 100px) 100px;
}

.status-squad-icon {
  width: 10px;
  height: 10px;
  display: inline-block;
  vertical-align: inherit;
  margin: 0 6px 0 0;
  background-color: orange;
}
.status-button {
  background-color: orange;
  color: white;
}
.status-button:hover {
  background-color: orange;
  color: white;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  transform: scale(1.05);
  transition: ease-in-out .25s transform;
  border-color: rgba(149, 157, 165, 0.2);
}
.status-button:focus {
  border-color: rgba(149, 157, 165, 0.2);
}
.status-squad-icon.color-5, .status-button.color-5, .status-button:hover.color-5 {
  background-color: yellow;
  color: black;
}
.status-squad-icon.color-6, .status-button.color-6, .status-button:hover.color-6 {
  background-color: cadetblue;
}
.status-squad-icon.color-7, .status-button.color-7, .status-button:hover.color-7 {
  background-color: green;
}
.status-squad-icon.color-8, .status-button.color-8, .status-button:hover.color-8 {
  background-color: violet;
}
.status-squad-icon.color-9, .status-button.color-9, .status-button:hover.color-9 {
  background-color: rebeccapurple;
}
.status-squad-icon.color-10, .status-button.color-10, .status-button:hover.color-10 {
  background-color: red;
}
.status-squad-icon.color-11, .status-button.color-11, .status-button:hover.color-11 {
  background-color: plum;
  color: black;
}
.status-squad-icon.color-12, .status-button.color-12, .status-button:hover.color-12 {
  background-color: teal;
}
.status-squad-icon.color-13, .status-button.color-13, .status-button:hover.color-13 {
  background-color: tomato;
}
.status-squad-icon.color-14, .status-button.color-14, .status-button:hover.color-14 {
  background-color: turquoise;
}
</style>
